import React, { Component } from 'react'
import { MultipleCardViewLoader } from 'components/Loaders/MultipleCardViewLoader';


const getContents = (size) => {
  const array = [];

  for (let index = 0; index < size; index++) {
    array[index] = index
  }

  return array.map((i) => {
    return (
      <div className="col-md-12 col-lg-6 col-xl-4 margin-t-0 margin-b-20" key={i}>
        <MultipleCardViewLoader />
      </div>
    )
  });
}

export class MultipleReportCardPlaceHolders extends Component {
  render() {
    const { size = 3 } = this.props;

    return (
      <div className="row">
        {
          getContents(size)
        }
      </div>
    )
  }
}

export default MultipleReportCardPlaceHolders;
